import { UserModel } from 'api/model';
import { atom, useRecoilState, useRecoilValue } from 'recoil';
import { useApiCallFn } from 'hooks/useApiCallFn';
import { useUserGetUsersHook } from 'api/user/user';

export const usersAtom = atom<{ [userId: string]: UserModel }>({
  key: 'usersLookup',
  default: {},
});

export const useRefreshUsersCall = () => {
  const [, setState] = useRecoilState(usersAtom);

  const getUsers = useUserGetUsersHook();

  const apiCall = useApiCallFn(async () => {
    const r = await getUsers();

    setState(r);

    return r;
  });

  return apiCall;
};

const useUsers = () => {
  return useRecoilValue(usersAtom);
};

export default useUsers;
